import { useCallback, useContext, useMemo } from 'react';
import { UserSessionContext } from 'components/UserSession';

const useCurrentAttendee = () => {
  const {
    userSession: {
      customAttendeeFields: {
        vexpo_chat_tag: userTag = null,
        vexpo_chat_user_description: userDescription = null,
        vexpo_exhibitor_booth_id: exhibitorBoothId = null,
      } = {},
      name = null,
      firstName = null,
      lastName = null,
      email = null,
      rongcloudUserId: uuid = null,
      rongcloudUser: {
        id: gqlId = null,
      } = {},
      authToken = null,
      role = null,
    } = {},
    canPerformVisitEventUnrestricted: isBackendOrganizer,
  } = useContext(UserSessionContext);

  const isCurrentAttendee = useCallback((compareId: string) => compareId === uuid, [uuid]);
  const isOrganizer = useMemo(() => (role as string)?.toLowerCase() === 'organizer' || isBackendOrganizer, [role, isBackendOrganizer]);
  const isExhibitor = useMemo(() => (role as string)?.toLowerCase() === 'exhibitor', [role]);

  return useMemo(() => ({
    uuid,
    name,
    firstName,
    lastName,
    email,
    userTag,
    userDescription,
    authToken,
    gqlId,
    isCurrentAttendee,
    isOrganizer,
    isExhibitor,
    exhibitorBoothId,
    role,
  }), [
    uuid,
    name,
    firstName,
    lastName,
    email,
    userTag,
    userDescription,
    authToken,
    gqlId,
    isCurrentAttendee,
    isOrganizer,
    isExhibitor,
    exhibitorBoothId,
    role,
  ]);
};

export default useCurrentAttendee;
